import { flex } from "@styled-system/patterns";

export const buttonsWrapperClass = flex({
	gap: "8",
	justifyContent: "flex-end",
	width: "full",
});
